<template>
    <div>
        <div class="listingPageTitle">
            <h1>Accordion Maintenance</h1>
            <ItemModal :itemName="'Accordion'"
                            :formRows="newItemFormRows"
                            :saveItemFunction="saveRecord"
                            :refreshItemsFunction="loadRecords"></ItemModal>
        </div>
        <div class="searchContainer">
            <div class="formRow"><span class="inputTitle">Search Name: </span><input type="text" v-model="searchText" /></div>
            <div class="formRow"><span class="inputTitle">Active Only: </span><input type="checkbox" v-model="onlyShowActive" /></div>
        </div>
        <hr />
        <ListingTable :columns="columns" :filterCriteria="filterCriteria" :actions="actionMappings" 
            :key="componentKey" :intitializationParameters="{ sortBy: 'id', sortDirection: 'desc'}" />
    </div>
</template>

<script>
import { data } from '../../shared/data';
import ItemModal from '@/components/ItemModal.vue';
import ListingTable from '@/components/shared/ListingTable.vue';

export default {
    name: 'AccordionListing',
    components: { ItemModal, ListingTable },
    data: function() {
        return {
            user: {},
            accordions: [],
            searchText: '',
            onlyShowActive: true,
            componentKey: 0,
            columns: [ 
                {
                    headerDisplayName: "ID",
                    width: "10%",
                    fieldName: "id"
                },
                {
                    headerDisplayName: "Name",
                    width: "50%",
                    fieldName: "name",
                    isEditLink: true
                },
                {
                    headerDisplayName: "Code",
                    width: "25%",
                    fieldName: "code"
                },
                {
                    headerDisplayName: 'Test',
                    width: "5%",
                    columnType: 'buttons',
                    showListingFieldName: 'true'
                },
                {
                    width: "5%",
                    columnType: "buttons",
                    showDeleteFieldName: "isActive",
                    showUndeleteFieldName: "!isActive"
                }
            ],
            newItemFormRows: [
                {
                    name: 'Name',
                    propertyName: 'name',
                    required: true,
                    element: 'input'
                },
                {
                    name: 'Code',
                    propertyName: 'code',
                    required: true,
                    element: 'input'
                },
                {
                    name: 'CSS File Name',
                    propertyName: 'cssFileName',
                    required: false,
                    element: 'input'
                },
                {
                    name: 'Activate one section at a time',
                    propertyName: 'isOnlyOneActiveSection',
                    required: false,
                    element: 'checkbox'
                }
            ],
            actionMappings: {
                onLoadData: this.loadRecords,
                onDelete: this.deleteRecord, 
                onUndelete: this.reactivateRecord,
                editHrefBuilder: this.editHrefBuilder,
                onShowListing: this.showTestConfiguration
            },
        };
    },
    computed: {
        filterCriteria () {
            var criteria = [];
            if(this.searchText != "") 
                criteria.push( {
                    dataType: "String",
                    fieldName: "name",
                    value: this.searchText
                });

            if(this.onlyShowActive) {
                criteria.push( {
                    dataType: "Boolean",
                    fieldName: "isActive",
                    value: true
                });

            }
            return criteria;
        }
    },
    methods: {
        loadRecords: async function() {
            return await data.getAllAccordions('', false);
        },
        editHrefBuilder: function(acc) {
            return '/AccordionEdit?ID=' + acc.id + '&Code=' + acc.code;
        },
        deleteRecord: async function(acc) {
            if(confirm('Are you sure you want to delete this accordion?')) {
                this.processDeactivateResult(await data.deleteAccordion(acc.id));  
                acc.isActive = false;
            }

        },
        reactivateRecord: async function(acc) {
            acc.isActive = true;
            var status = await this.saveAccordion(acc);
            if(!status.success)
                acc.isActive = false;
        },
        saveRecord: async function(acc) {
            acc.languages = ["English"];
            acc.defaultLanguage = 'English';
            return await this.saveAccordion(acc, true);
        },
        saveAccordion: async function(acc, redirectToEditFlag) {
            var retObject = this.processSaveResult(await data.saveAccordion(acc));
            if(retObject.success) {
                if(redirectToEditFlag && retObject.id) {
                    acc.id = retObject.id;
                    window.location.href = this.editHrefBuilder(acc);
                }
                else 
                    return retObject;
            }
            else
                return retObject;
        },
        showTestConfiguration: async function(acc) {
            const testConfiguration = await data.getTestConfigurationByAccordionId(acc.id);
            if(testConfiguration && testConfiguration.id > 0) {
                window.location.href = '/testconfiguration?id=' + testConfiguration.id;
            } else {
                const tc = { accordionId: acc.id }
                const result = this.processSaveResult(await data.saveTestConfiguration(tc));
                window.location.href = '/testconfiguration?id=' + result.id;
            }
        }
    }
}
</script>